<template>
  <v-app id="sandbox">
    <v-container v-if="!ready">
      <v-layout align-center justify-center row fill-height>
      <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-layout>
    </v-container>
    <template v-else>
      <v-navigation-drawer
        :permanent="true"
        :temporary="false"
        :clipped="true"
        :floating="true"
        :mini-variant="false"
        absolute
        overflow
        app
      >
        <div class="centered mt-5 mb-3 px-3">
          <router-link tag="div" to="/projects/create">
            <v-btn outline color="info" >Créer un nouveau project</v-btn>
          </router-link>
          <v-text-field
            v-model="search"
            solo
            label="Recherche ..."
            append-icon="search"
            class="pt-4"
            clearable
          ></v-text-field>
        </div>
        <v-divider></v-divider>
        <v-list  class="py-0" v-if="filteredProject.length > 0">
          <template v-for="project in filteredProject">
            <router-link tag="div" class="navigation_project" :key="project.id" :to="{ name: 'ProjectDetail', params: { projectId: project.id }}">
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>{{project.name}}</v-list-tile-title>
                  <v-list-tile-sub-title>{{project.createdAt | formatDate('DD/MM/YYYY HH:mm')}}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider/>
            </router-link>
          </template>
        </v-list>
        <div v-else class="headline text-sm-center px-3 py-3 font-weight-thin">
          <div v-if="projects.length === 0">Veuillez créer un projet</div>
          <div v-else>Aucun projet ne correspond</div>

        </div>
      </v-navigation-drawer>
      <v-toolbar :clipped-left="true" app absolute>
        <router-link to="/" tag="span">
          <v-toolbar-title>ToolTranslate</v-toolbar-title>
        </router-link>
        <v-spacer></v-spacer>
        <div class="text-xs-center">
          <v-menu offset-y :nudge-top="-20" min-width="300">
            <template v-slot:activator="{ on }">
              <v-avatar
                :size="40"
                color="grey lighten-4"
                v-on="on"
              >
                <img :src="user.gravatarUrl" alt="avatar">
              </v-avatar>
            </template>
            <v-list>
              <v-list-tile avatar class="avatar-login-wrapper">
                <v-list-tile-avatar>
                  <img :src="user.gravatarUrl" alt="avatar">
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title>{{user.firstname}} {{user.lastname}}</v-list-tile-title>
                  <v-list-tile-sub-title>{{user.email}}</v-list-tile-sub-title>
                  <v-list-tile-title class="logout mt-2">
                    <a href="#" @click.prevent="onLogout">Se déconnecter</a>
                  </v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>
        </div>
      </v-toolbar>
      <v-content>
        <v-container fluid>
          <router-view/>
        </v-container>
      </v-content>
      <v-snackbar
        v-model="snackbar.display"
        :color="snackbar.color"
        :timeout="snackbar.timeout"
        top
        right
      >
        {{ snackbar.text }}
        <v-btn
          dark
          flat
          v-if="snackbar.close"
          @click="closeSnackbar"
        >
          Fermer
        </v-btn>
      </v-snackbar>
    </template>
  </v-app>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import get from 'lodash/get';
  export default {
    data: () => ({
      ready: false,
      search: '',
    }),
    async mounted() {
      try {
        const response = await this.$http.get('/api/projects/list');
        this.setProjects(response.data);
        this.ready = true;
      } catch (e) {
        alert('Impossible de charger l\'application');
      }

    },
    computed: {
      ...mapGetters({
        user: 'user',
        projects: 'projects',
        snackbar: 'snackbar',
      }),
      filteredProject() {
        const search = (this.search === null ? '': this.search).toLowerCase().trim();
        return get(this, 'projects', []).filter(p => p.name.toLowerCase().indexOf(search) > -1);
      }
    },
    methods: {
      ...mapActions({
        logout: 'logout',
        setProjects: 'setProjects',
        closeSnackbar: 'closeSnackbar',
      }),
      onLogout() {
        this.logout();
        this.$router.push({ name: 'Login' });
      },
    }
  }
</script>
<style  lang="scss" scoped>
  .centered {
    text-align: center;
  }
  /deep/ .avatar-login-wrapper {
    > .v-list__tile {
      align-items: start;
    }
    > .v-list__tile--avatar {
      height: auto;
    }
    .logout {
      a {
        text-decoration: none;
      }
    }
  }
  .navigation_project {
    cursor: pointer;
  }
</style>
